import store from '../../store';

export default [
  {
    name: "Reports",
    path: "/reports",
    component: () => import('@/views/reports/ReportsBase.vue'),
    meta: {
      isInMenu: true,
      title: 'main-menu.reports.title',
      icon: 'fas fa-chart-line',
      type: 'title',
      order: 1,
      access_control: ['ROLE_ADMIN', 'ROLE_RECEPTIONIST']
    },
    children: [
      {
        name: "usage_report",
        path: "/reports/usage-reports",
        meta: {
          isInMenu: true,
          title: "main-menu.reports.usage-report",
          type: 'link',
          access_control: ['ROLE_ADMIN']
        },
        component: () => import('@/views/reports/usage-reports/TheUsageReports.vue')
      },
      {
        name: "usage_report_by_organization",
        path: "/reports/usage-reports-by-organization",
        component: () => import('@/views/reports/usage-reports/TheUsageReportByOrganization.vue'),
        meta: {
          isInMenu: false
        },
        props: route => ({ id: route.query.id, from: route.query.from, to: route.query.to })
      },
      {
        name: "switchBetweenDashboards",
        path: "/reports/dashboards",
        component: () => import('@/views/DashboardsSwitcher.vue'),
        meta: {
          title: 'main-menu.reports.dashboard-switcher',
          access_control: ['ROLE_ADMIN', 'ROLE_RECEPTIONIST'],
          requiresAuth: true,
          isInMenu: true,
          type: 'link'
        }
      },
      {
        name: "agentsDashboard",
        path: "/reports/agents-dashboard",
        component: () => import('@/views/AgentsDashboard.vue'),
        meta: {
          title: 'main-menu.reportes.dashboard-switcher',
          access_control: ['ROLE_ADMIN'],
          requiresAuth: true,
          isInMenu: false,
          type: 'link'
        }
      },
      {
        name: "queuesDashboard",
        path: "/reports/queues-dashboard",
        component: () => import('@/views/QueuesDashboard.vue'),
        meta: {
          title: 'main-menu.queue-dashboard',
          access_control: ['ROLE_ADMIN'],
          requiresAuth: true,
          isInMenu: false,
          type: 'link'
        }
      },
      {
        name: "queuesDashboardDetails",
        path: "/reports/queues-dashboard/:organization/:id",
        component: () => import('@/views/reports/queues-reports/TheQueuesDetails.vue'),
        meta: {
          access_control: ['ROLE_ADMIN'],
          requiresAuth: true,
          isInMenu: false,
          type: 'link'
        },
        beforeEnter: (to, from, next) => {
          const id = to.params.id;
          if (!store.getters["getQueueDashboardFromList"](id)) {
            return next({ name : "queuesDashboard"});
          }
          return next();
        }
      },
      {
        name: "extensionsDashboard",
        path: "/reports/extensions-dashboard",
        component: () => import('@/views/ExtensionsDashboard.vue'),
        meta: {
          title: 'main-menu.extensions-dashboard',
          access_control: ['ROLE_ADMIN', 'ROLE_RECEPTIONIST'],
          requiresAuth: true,
          isInMenu: false,
          type: 'link'
        }
      },
      {
        name: "users-audit",
        path: "users-audit",
        meta: {
          isInMenu: true,
          title: 'main-menu.reports.users-audit',
          access_control: ['ROLE_ADMIN'],
          requiresAuth: true
        },
        component: () => import('@/views/reports/audit/TheUserLoginLogoutReport.vue')
      },
    ]
  }
];
